// export const API_BASE_URL = 'https://web.cyberbells.com/development/Cyberbells_pms';
// export const API_BASE_URL = 'http://5.161.212.143:4040/api';
// export const API_BASE_URL = 'http://38.146.28.229:4040/api';


// export const API_BASE_URL = 'http://localhost:5000/api';

export const API_BASE_URL = 'https://cyberpulse360.com/api';


